import Vue from 'vue'

export const labels = {
    state: {
        status: 'idle',
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        },
        labels: null,
        selectAll: false,
        selectedLabels: [],
        price_tags: {
            merchant_header: true,
            guides: true,
            variant: 'normal',
            price_tags_attributes: []
        },
        sortOptions: [
            {
                query: 'id',
                label: 'ID'
            },
            {
                query: 'name',
                label: 'Nazwa'
            }
        ],
        sort: {
            by: 'id',
            direction: 'desc'
        },
        filters: {
            name: {
                type: 'search-input',
                value: '',
                text: 'Wpisz nazwę promocji'
            },
            company_id: {
                type: 'ui-virtual-list',
                value: [],
                searcher: false,
                getter: 'getCompaniesForLabelFilters',
                moduleName: 'companies',
                label: 'Organizator'
            },
            productNames: {
                type: 'ui-virtual-list',
                value: null,
                moduleName: 'products',
                getter: 'getProductNamesForFilters',
                label: 'Produkt'
            }
        },
        companiesForLabelFilters: [],
        // TODO uncomment when api ready
        // promoTypes: 'Promo::PeriodicPriceReduction,Promo::Plan',
        // TODO delete Promo::WeightPeriodicPriceReduction in promoTypes - #782
        promoTypes:
            'Promo::PeriodicPriceReduction,Promo::Mix1,Promo::WeightPeriodicPriceReduction',
        downloadStatus: 'idle',
        shopsContacts: [],
        selectedShopContacts: [],
        regularPricesDownloadState: 'idle'
    },
    mutations: {
        SET_REGULAR_PRICES_DOWNLOAD_STATE(state, payload) {
            state.regularPricesDownloadState = payload
        },
        SET_LABELS(state, payload) {
            state.labels = payload
        },
        SET_LABELS_STATUS(state, status) {
            state.status = status
        },
        SET_SELECT_ALL_LABELS(state, payload) {
            state.selectAll = payload
        },
        SET_LABELS_PAGINATION(state, payload) {
            state.pagination = payload
        },
        SET_LABELS_PER_PAGE(state, payload) {
            state.pagination.perPage = payload
        },
        SET_LABELS_PAGINATION_CURRENT(state, payload) {
            state.pagination.page = payload
        },
        SELECT_LABEL(state, payload) {
            state.selectedLabels = payload
        },
        SELECT_LABEL_SHOP(state, payload) {
            state.price_tags.price_tags_attributes = payload
        },
        SET_DOWNLOAD_LABELS_STATUS(state, payload) {
            state.downloadStatus = payload
        },
        SET_LABEL_TYPE(state, payload) {
            state.price_tags.variant = payload
        },
        SET_LABELS_SORT(state, payload) {
            state.sort = payload
        },
        SET_LABEL_MERCHANT_HEADER(state, payload) {
            state.price_tags.merchant_header = payload
        },
        SET_LABEL_GUIDES(state, payload) {
            state.price_tags.guides = payload
        },
        SET_PRICE_TAGS(state, payload) {
            state.price_tags.price_tags_attributes = payload
        },
        SET_PRICE_TAGS_PARAM(state, payload) {
            state.price_tags[payload.param] = payload.value
        },
        SET_LABELS_FILTER(state, payload) {
            Vue.set(state.filters[payload.filter], 'value', payload.value)
        },
        RESET_LABELS_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        },
        SET_LABELS_PROMOTYPES(state, payload) {
            state.promoTypes = payload
        },
        SET_SHOPCONTACTS(state, payload) {
            state.shopsContacts = payload
        },
        SET_SELECTED_SHOPCONTACTS(state, payload) {
            state.selectedShopContacts = payload
        },
        SET_COMPANIES_FOR_LABEL_FILTERS(state, payload) {
            state.companiesForLabelFilters = payload
        }
    },
    actions: {
        async getRegularEanPrices({ getters, commit, dispatch }, singlePromo) {
            commit('SET_REGULAR_PRICES_DOWNLOAD_STATE', 'pending')

            const params = []
            let labels

            if (singlePromo) {
                labels = getters.getSelectedLabels.filter(
                    label => label.id === singlePromo.id
                )
            } else {
                labels = getters.getSelectedLabels.map(e => e)
            }

            labels = labels.map(e => e.labels)

            labels.forEach(label => {
                Object.values(label).forEach(product => {
                    const ean = product.ean
                    Object.values(product.subscriptions).forEach(
                        subscription => {
                            const foundMerchant = params.find(
                                e => e.merchant_id === subscription.merchant_id
                            )

                            if (foundMerchant) {
                                foundMerchant.ean.push(ean)
                            } else {
                                params.push({
                                    merchant_id: subscription.merchant_id,
                                    ean: [ean]
                                })
                            }
                        }
                    )
                })
            })

            try {
                const res = await this.$api.post(
                    'promo/regularEanPrice',
                    params
                )
                const response = res.data.data
                let tmpLabels

                if (singlePromo) {
                    tmpLabels = getters.getSelectedLabels.filter(
                        label => label.id === singlePromo.id
                    )
                } else {
                    tmpLabels = getters.getSelectedLabels.map(e => e)
                }

                tmpLabels.forEach((tmpLabel, labelIdx) => {
                    const promotionId = tmpLabel.id
                    Object.entries(tmpLabel.labels).forEach(entry => {
                        const productId = +entry[0]

                        const product = entry[1]
                        const ean = product.ean
                        let subscriptionCounter = 0
                        let addedRegularPricesCounter = 0

                        Object.entries(product.subscriptions).forEach(entry => {
                            const subscription = entry[1]

                            subscriptionCounter++
                            const foundRegularPriceObject = response.find(
                                e =>
                                    e.ean === ean &&
                                    e.merchant_id === subscription.merchant_id
                            )
                            if (foundRegularPriceObject) {
                                addedRegularPricesCounter++

                                subscription.regular_price = +foundRegularPriceObject.regular_price
                                subscription.price_normal = +foundRegularPriceObject.regular_price

                                dispatch('selectLabelShop', {
                                    download: true,
                                    subscription_id:
                                        subscription.subscription_id,
                                    product_set_dict_product_id: subscription.product_set_dict_product_id
                                        ? subscription.product_set_dict_product_id
                                        : null,
                                    product_set_subscription_id: subscription.product_set_subscription_id
                                        ? subscription.product_set_subscription_id
                                        : null,
                                    subscription_resource_id:
                                        subscription.subscription_resource_id,
                                    product_id: productId,
                                    price_normal: +foundRegularPriceObject.regular_price,
                                    print_copies: 1,
                                    promotion_id: promotionId,
                                    merchant_id: subscription.merchant_id,
                                    promoType: getters.getLabelTypeById(
                                        promotionId
                                    ),
                                    value: true
                                })
                            } else {
                                subscription.regular_price = null
                            }
                        })

                        const subsPrices = Object.values(
                            product.subscriptions
                        ).map(e => e.regular_price)

                        const areAllSubsPricesSame = subsPrices.every(
                            e => e === subsPrices[0] && +e > 0
                        )

                        const atLeastOneSubHasPrice =
                            addedRegularPricesCounter > 0

                        if (atLeastOneSubHasPrice) {
                            const prod = tmpLabels[labelIdx].products.find(
                                p => p.id === productId
                            )
                            if (prod) {
                                prod.downloadLabel = true
                            }

                            tmpLabels[labelIdx].product_sets.forEach(set => {
                                set.product_set_dict_products.forEach(
                                    singleProduct => {
                                        if (singleProduct.id === productId) {
                                            singleProduct.downloadLabel = true
                                        }
                                    }
                                )
                            })

                            product.downloadLabel = true
                            tmpLabel.accepted = true
                            tmpLabel.someSubsHasRegularPrice = true
                        }

                        if (areAllSubsPricesSame) {
                            product.price_default = subsPrices[0]
                        }

                        product.noRegularPriceInAllSubs =
                            addedRegularPricesCounter === 0

                        product.noRegularPriceInSomeSubs =
                            addedRegularPricesCounter !== subscriptionCounter
                    })

                    tmpLabel.regularPricesRequested = true

                    tmpLabel.noRegularPriceInSomeProducts = Object.values(
                        tmpLabel.labels
                    )
                        .map(product => product.noRegularPriceInSomeSubs)
                        .some(e => e === true)

                    tmpLabel.noRegularPriceInAllProducts = Object.values(
                        tmpLabel.labels
                    )
                        .map(product => product.noRegularPriceInAllSubs)
                        .every(e => e === true)
                })

                let newLabelsToSet = []

                if (singlePromo) {
                    getters.getSelectedLabels.forEach(label => {
                        if (label.id !== singlePromo.id) {
                            newLabelsToSet.push(label)
                        } else {
                            newLabelsToSet.push(tmpLabels[0])
                        }
                    })
                } else {
                    newLabelsToSet = tmpLabels
                }

                commit('SELECT_LABEL', newLabelsToSet)
                commit('SET_REGULAR_PRICES_DOWNLOAD_STATE', 'downloaded')
            } catch {
                commit('SET_REGULAR_PRICES_DOWNLOAD_STATE', 'idle')
                dispatch('addNotification', {
                    type: 'danger',
                    title: 'Cenówki',
                    content: 'Wystąpił błąd. Spróbuj ponownie później.'
                })
            }
        },
        toggleProductLabelDownload(
            { state, commit, getters },
            { productId, selected }
        ) {
            const tmpSelectedLabels = [...getters.getSelectedLabels]

            tmpSelectedLabels.forEach(element => {
                element.products &&
                    element.products.forEach(product => {
                        if (product.id === productId) {
                            product.downloadLabel = selected
                        }
                    })

                element.product_sets.forEach(productSet => {
                    productSet.product_set_dict_products &&
                        productSet.product_set_dict_products.forEach(
                            product => {
                                if (product.id === productId) {
                                    product.downloadLabel = selected
                                }
                            }
                        )
                })

                Object.keys(element.labels).forEach(labelKey => {
                    if (labelKey === `${productId}`) {
                        element.labels[labelKey].downloadLabel = selected
                    }
                })
            })
            commit('SELECT_LABEL', tmpSelectedLabels)
        },
        async setLabelsFilters({ state, commit, getters }) {
            if (getters.isLotteryUser) {
                const tmpFilters = Object.assign({}, state.filters)
                Object.entries(tmpFilters).forEach(entry => {
                    entry[1].inactive = true
                })
                commit('RESET_LABELS_FILTERS', tmpFilters)
            } else {
                const params = {
                    state: 'active',
                    'subscription|state': 'accepted',
                    'company_merchant|status': 'active',
                    type: state.promoTypes
                }

                const res = await this.$api.get(
                    'promos/aggregate/count/company_id',
                    { params }
                )

                const availableIds = Object.keys(res.data.data).map(e =>
                    parseInt(e)
                )

                const companies = getters.getCompaniesForFilters.filter(
                    company => {
                        if (availableIds.includes(company.value)) {
                            return company
                        }
                    }
                )
                commit('SET_COMPANIES_FOR_LABEL_FILTERS', companies)
            }
        },
        selectAllLabels({ commit, getters }, payload) {
            if (payload) {
                const availableLabels = getters.getLabels
                const selectedLabels = getters.getSelectedLabels

                const selectedLabelsIds = getters.getSelectedLabels.map(
                    e => e.id
                )
                availableLabels.forEach(label => {
                    if (selectedLabelsIds.indexOf(label.id) < 0) {
                        selectedLabels.push(label)
                    }
                })

                this.$storage.setItem('selectedLabels', selectedLabels)
                commit('SELECT_LABEL', selectedLabels)
            } else {
                if (getters.getLabels) {
                    const idsToUnselect = getters.getLabels.map(e => e.id)

                    const selectedLabels = getters.getSelectedLabels.filter(
                        label => {
                            return idsToUnselect.indexOf(label.id) === -1
                        }
                    )

                    this.$storage.setItem('priceTags', [])
                    commit('SELECT_LABEL_SHOP', [])
                    this.$storage.setItem('selectedLabels', selectedLabels)

                    commit('SELECT_LABEL', selectedLabels)
                }
            }
            commit('SET_SELECT_ALL_LABELS', payload)
        },
        unselectAllLabels({ state, commit }) {
            state.labels.forEach(label => {
                label.accepted = false
            })
            this.$storage.setItem('priceTags', [])
            commit('SELECT_LABEL_SHOP', [])
            this.$storage.setItem('selectedLabels', [])
            commit('SELECT_LABEL', [])
            commit('SET_SELECT_ALL_LABELS', false)
        },
        selectLabel({ state, commit, dispatch }, payload) {
            let promotions = state.selectedLabels
            const promotionIds = promotions.map(item => item.id)

            if (promotionIds.includes(payload.id) && !payload.value) {
                // remove from selected labels
                promotions = promotions.filter(item => item.id !== payload.id)

                // remove also priceTags with promotion_id
                let priceTags = state.price_tags.price_tags_attributes
                priceTags = priceTags.filter(
                    el => el.promotion_id !== payload.id
                )
                this.$storage.setItem('priceTags', priceTags)
                commit('SELECT_LABEL_SHOP', priceTags)
                commit('SET_SELECT_ALL_LABELS', false)
            } else {
                let promotion
                if (payload.generateLabel) {
                    promotion = payload.promo
                    promotion.regularPricesRequested = false
                    promotion.someSubsHasRegularPrice = undefined
                    promotion.noRegularPriceInSomeProducts = undefined
                    promotion.noRegularPriceInAllProducts = undefined

                    if (!promotionIds.includes(payload.id)) {
                        promotions.push(promotion)
                    }
                } else {
                    promotion = state.labels.find(
                        item => item.id === payload.id
                    )
                    promotion.regularPricesRequested = false
                    promotion.someSubsHasRegularPrice = undefined
                    promotion.noRegularPriceInSomeProducts = undefined
                    promotion.noRegularPriceInAllProducts = undefined
                    promotions.push(promotion)
                }
            }

            if (promotions.length === 0) {
                dispatch('toggleModal', false)
            }
            this.$storage.setItem('selectedLabels', promotions)

            commit('SELECT_LABEL', promotions)
        },
        selectLabelShop({ state, commit, dispatch }, payload) {
            if (+payload.price_normal > 0) {
                dispatch('toggleProductLabelDownload', {
                    productId: payload.product_id,
                    selected: true
                })
            }

            let priceTags = state.price_tags.price_tags_attributes
            const subscriptionIds = priceTags.map(item => item.subscription_id)
            const productIds = priceTags.map(item => item.product_id)

            // remove if merchant with sub_id && product_id equals to payload already exists
            if (!payload.value) {
                if (
                    subscriptionIds.includes(payload.subscription_id) &&
                    productIds.includes(payload.product_id)
                ) {
                    priceTags = priceTags.filter(
                        item =>
                            item.subscription_id !== payload.subscription_id ||
                            item.product_id !== payload.product_id
                    )
                }
            } else {
                const selectedLabels = JSON.parse(
                    JSON.stringify(state.selectedLabels)
                )
                const promo = selectedLabels.find(
                    promo => promo.id === payload.promotion_id
                )
                const product = promo.labels[payload.product_id]
                const subscription =
                    product.subscriptions[payload.subscription_id]
                subscription.price_normal = payload.price_normal
                subscription.print_copies = payload.print_copies
                // if check true
                // delete payload.value
                if (payload.download && payload.price_normal) {
                    // filter to update value
                    priceTags = priceTags.filter(
                        item =>
                            item.subscription_id !== payload.subscription_id ||
                            item.product_id !== payload.product_id
                    )
                    if (
                        payload.price_normal !== '' &&
                        payload.price_normal !== '0' &&
                        payload.price_normal !== 0 &&
                        payload.price_normal !== '0.00' &&
                        payload.print_copies !== 0
                    ) {
                        priceTags.push(payload)
                    }

                    this.$storage.setItem('selectedLabels', selectedLabels)
                    commit('SELECT_LABEL', selectedLabels)
                } else {
                    if (
                        subscriptionIds.includes(payload.subscription_id) &&
                        productIds.includes(payload.product_id)
                    ) {
                        priceTags = priceTags.filter(
                            item =>
                                item.subscription_id !==
                                    payload.subscription_id ||
                                item.product_id !== payload.product_id
                        )
                    }
                }
            }

            this.$storage.setItem('priceTags', priceTags)
            commit('SELECT_LABEL_SHOP', priceTags)
        },
        async selectLabelShops({ state, commit }, payload) {
            let priceTags = state.price_tags.price_tags_attributes
            const selectedLabels = state.selectedLabels

            const promotions = payload.shops
                .filter(item => {
                    const promo = selectedLabels.find(
                        promo => promo.id === payload.promotion_id
                    )
                    const product = promo.labels[payload.product_id]
                    const subscription =
                        product.subscriptions[item.subscription_id]

                    return (
                        item.merchant_id &&
                        payload.download &&
                        subscription.price_normal &&
                        subscription.price_normal !== '' &&
                        subscription.price_normal !== '0' &&
                        subscription.price_normal !== 0 &&
                        subscription.price_normal !== '0.00' &&
                        subscription.print_copies !== 0
                    )
                })
                .map(item => {
                    const promo = selectedLabels.find(
                        promo => promo.id === payload.promotion_id
                    )
                    const product = promo.labels[payload.product_id]
                    const subscription =
                        product.subscriptions[item.subscription_id]

                    // for promoMix
                    if (payload.product_set) {
                        return {
                            print_copies:
                                subscription.print_copies > 0
                                    ? subscription.print_copies
                                    : 1,
                            price_normal: subscription.price_normal,
                            price_regular: subscription.regular_price,
                            product_set_subscription_id:
                                item.product_set_subscription_id,
                            product_set_dict_product_id: payload.product_id,
                            subscription_id: item.subscription_id,
                            subscription_resource_id:
                                item.subscription_resource_id,
                            product_id: payload.product_id,
                            merchant_id: item.merchant_id,
                            promoType: item.promoType,
                            promotion_id: payload.promotion_id
                        }
                    } else {
                        return {
                            print_copies:
                                subscription.print_copies > 0
                                    ? subscription.print_copies
                                    : 1,
                            price_normal: subscription.price_normal,
                            price_regular: subscription.regular_price,
                            subscription_id: item.subscription_id,
                            subscription_resource_id:
                                item.subscription_resource_id,
                            product_id: payload.product_id,
                            promotion_id: payload.promotion_id,
                            merchant_id: item.merchant_id,
                            promoType: item.promoType
                        }
                    }
                })

            if (payload.value) {
                // avoid duplicates
                promotions.forEach(el => {
                    const tagIndex = priceTags.findIndex(
                        pt =>
                            pt.subscription_id === el.subscription_id &&
                            pt.product_id === el.product_id
                    )

                    if (tagIndex < 0) {
                        priceTags.push(el)
                    } else {
                        priceTags[tagIndex] = el
                    }
                })
            } else {
                priceTags = priceTags.filter(
                    el =>
                        el.product_id !== payload.product_id ||
                        el.promotion_id !== payload.promotion_id
                )
            }
            this.$storage.setItem('priceTags', priceTags)
            commit('SELECT_LABEL_SHOP', priceTags)

            const tmpSelectedLabels = selectedLabels.map(promo => {
                if (promo.id === payload.promotion_id) {
                    promo.products.forEach(product => {
                        if (product.id === payload.product_id) {
                            product.downloadLabel = payload.value
                        }
                    })

                    promo.product_sets.forEach(el => {
                        el.product_set_dict_products.forEach(el => {
                            if (el.id === payload.product_id) {
                                el.downloadLabel = payload.value
                            }
                        })
                    })

                    promo.labels[payload.product_id].downloadLabel =
                        payload.value
                }
                return promo
            })

            commit('SELECT_LABEL', tmpSelectedLabels)
        },
        setLabelDefaults({ state, commit }, payload) {
            const labels = state.selectedLabels
            const label = labels.find(el => {
                return el.id === payload.promotion_id
            })
            label.labels[payload.product_id].price_default =
                payload.price_default
            label.labels[payload.product_id].print_default =
                payload.print_default
            commit('SELECT_LABEL', labels)
        },
        setLabelsPagination({ commit }, payload) {
            commit('SET_LABELS_PAGINATION', payload)
        },
        setLabelsPaginationCurrent({ commit }, payload) {
            commit('SET_LABELS_PAGINATION_CURRENT', payload)
        },
        setLabelsPerPage({ commit }, payload) {
            commit('SET_LABELS_PER_PAGE', payload)
        },
        downloadLabels({ state, commit, getters }) {
            if (state.downloadStatus === 'idle') {
                commit('SET_DOWNLOAD_LABELS_STATUS', 'loading')
                this.$api
                    .post(
                        'price_tags/download',
                        {
                            ...state.price_tags
                        },
                        {
                            responseType: 'arraybuffer'
                        }
                    )
                    .then(response => {
                        const today = Vue.moment().format('YYYY-MM-DD')

                        const fileLink = document.createElement('a')
                        const blob = new Blob([response.data], {
                            type: 'application/pdf'
                        })

                        // if (payload === 'print') {
                        //     blob = new Blob([response.data], { type: '"application/pdf"' })
                        //     window.open(blob, '_blank')
                        // } else {
                        fileLink.href = window.URL.createObjectURL(blob)
                        fileLink.download = `Cenowki-${today}.pdf`
                        fileLink.click()
                        // fileLink.setAttribute('download', `Cenowki-${today}.pdf`)
                        // fileLink.setAttribute('target', '_blank')
                        // fileLink.href = blob
                        // fileLink.click()
                        // }
                        commit('SET_DOWNLOAD_LABELS_STATUS', 'idle')
                    })
                    .catch(err => {
                        commit('SET_DOWNLOAD_LABELS_STATUS', 'idle')
                    })
            }
        },
        setLabelType({ commit }, payload) {
            commit('SET_LABEL_TYPE', payload)
        },
        setLabelsSort({ commit }, payload) {
            commit('SET_LABELS_SORT', payload)
        },
        loadPriceTags({ commit }) {
            return this.$storage.getItem('priceTags').then(res => {
                if (res) {
                    commit('SET_PRICE_TAGS', res)
                }
            })
        },
        setLabelMerchantHeader({ commit }, payload) {
            commit('SET_PRICE_TAGS_PARAM', {
                value: payload,
                param: 'merchant_header'
            })
        },
        setLabelGuides({ commit }, payload) {
            commit('SET_PRICE_TAGS_PARAM', {
                value: payload,
                param: 'guides'
            })
        },
        restorePriceTags({ commit }, payload) {
            this.$storage.setItem('priceTags', payload)
            commit('SET_PRICE_TAGS', payload)
        },
        resetPriceTags({ commit }) {
            this.$storage.getItem('initialState').then(response => {
                commit('SET_PRICE_TAGS', response.labels.priceTags)
                this.$storage.setItem('priceTags', response.labels.priceTags)
            })
        },
        restoreSelectedLabels({ commit }, payload) {
            this.$storage.setItem('selectedLabels', payload)
            commit('SELECT_LABEL', payload)
        },
        setLabelsPromoTypes({ commit }, payload) {
            commit('SET_LABELS_PROMOTYPES', payload)
        },
        shopsContactsFetch({ commit }) {
            this.$api.get('shopsContacts').then(res => {
                commit('SET_SHOPCONTACTS', res.data.data)
            })
        },
        selectShopContacts({ commit }, payload) {
            const contactShops = document.querySelectorAll('.contact-shop')
            const contacts = []
            if (payload) {
                contactShops.forEach(el => {
                    if (
                        el.attributes.contact_person_name.value &&
                        el.attributes.contact_person_email.value
                    ) {
                        const isEmail = (email = null) => {
                            // eslint-disable-next-line
                            const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                            return regex.test(email)
                        }
                        if (isEmail(el.attributes.contact_person_email.value)) {
                            contacts.push({
                                shop_id: el.attributes.shop_id.value,
                                contact_person_name:
                                    el.attributes.contact_person_name.value,
                                contact_person_email:
                                    el.attributes.contact_person_email.value
                            })
                        }
                    }
                })
            }
            commit('SET_SELECTED_SHOPCONTACTS', contacts)
        },
        selectShopContact({ commit, state }, payload) {
            let selected = state.selectedShopContacts
            const findContact = selected.find(
                el => el.shop_id === payload.shop_id
            )

            if (!payload.selected) {
                selected = selected.filter(
                    el => +el.shop_id !== payload.shop_id
                )
            } else {
                delete payload.selected
                if (findContact) {
                    const findIndex = selected.findIndex(
                        el => +el.shop_id === payload.shop_id
                    )
                    selected[findIndex] = payload
                } else {
                    selected.push(payload)
                }
            }
            commit('SET_SELECTED_SHOPCONTACTS', selected)
        },
        sendLabels({ state }) {
            this.$api
                .post('saveShopsContacts', state.selectedShopContacts)
                .then(res => {
                    if (res.status === 200) {
                        this.$api.post('price_tags/send_email', {
                            ...state.price_tags,
                            selectedManagers: state.selectedShopContacts.map(
                                el => el.shop_id
                            )
                        })
                    }
                })
        },
        setLabelsCurrentPage({ commit }, payload) {
            commit('SET_LABELS_PAGINATION_CURRENT', payload)
        },
        setLabelAccepted({ state, commit }, payload) {
            const selectedLabels = [...state.selectedLabels]
            const searchedLabel = {
                ...selectedLabels.find(el => el.id === payload.id)
            }
            const restLabels = [
                ...selectedLabels.filter(el => el.id !== payload.id)
            ]
            searchedLabel.accepted = true
            commit('SELECT_LABEL', [...restLabels, searchedLabel])
        }
    },
    getters: {
        getCompaniesForLabelFilters: state => state.companiesForLabelFilters,
        getLabels: state => {
            if (state.labels) {
                return state.labels
            }
        },
        getLabelsSelectAll: state => {
            return state.selectAll
        },
        getSelectedLabels: state => {
            return state.selectedLabels
        },
        getSelectedLabelBoolean: state => id => {
            if (state.selectedLabels) {
                if (state.selectedLabels.find(item => item.id === id)) {
                    return true
                } else {
                    return false
                }
            }
        },
        getSelectedLabelShop: state => obj => {
            if (state.price_tags.price_tags_attributes) {
                if (
                    state.price_tags.price_tags_attributes.find(
                        item =>
                            item.subscription_id === obj.subId &&
                            item.product_id === obj.productId
                    )
                ) {
                    return state.price_tags.price_tags_attributes.find(
                        item =>
                            item.subscription_id === obj.subId &&
                            item.product_id === obj.productId
                    )
                } else {
                    return false
                }
            }
        },
        getLabelsPagination: state => {
            return state.pagination
        },
        getLabelsTotalRecords: state => {
            return state.pagination.totalRecords
        },
        getDownloadLabelsStatus: state => {
            return state.downloadStatus
        },
        getLabelsSortOptions: state => {
            return state.sortOptions
        },
        getLabelsSort: state => {
            return state.sort
        },
        getLabelType: state => {
            return state.price_tags.variant
        },
        getSelectedLabelsCount: state => {
            return state.selectedLabels.length
        },
        getPriceTags: state => {
            return state.price_tags.price_tags_attributes
        },
        getLabelMerchantHeader: state => {
            return state.price_tags.merchant_header
        },
        getLabelGuides: state => {
            return state.price_tags.guides
        },
        getLabelsFilters: state => {
            return state.filters
        },
        getShopContactById: state => shopId => {
            if (state.shopsContacts) {
                return state.shopsContacts.find(el => el.shop_id === shopId)
            } else {
                return false
            }
        },
        getSelectedShopContacts: state => {
            if (state.selectedShopContacts) {
                return state.selectedShopContacts
            }
        },
        getSelectedShopContactById: state => shopId => {
            if (state.selectedShopContacts) {
                const find = state.selectedShopContacts.find(
                    el => +el.shop_id === shopId
                )
                if (find) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        getLabelTypeById: state => id => {
            if (state.selectedLabels) {
                let type = state.selectedLabels.find(item => item.id === id)
                    .type
                type = type.toLowerCase()
                return type.includes('mix') ? 'mix' : 'promo'
            }
        },
        getRegularPricesDownloadState: state => state.regularPricesDownloadState
    }
}
